import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './PasswordProtect.scss';

function PasswordProtect() {
  const navigate = useNavigate();
  const [isWrongPassword, setIsWrongPassword] = useState(false);

  const checkPassword = (password: string) => {
    const correctPassword = 'wanderingwheretogo';
    if (password.toLowerCase() === correctPassword) {
      localStorage.setItem('isAuthenticated', 'true');
      navigate(-1);
      window.location.reload();
    } else {
      setIsWrongPassword(true);
    }
  };

  return (
    <div className='password-page'>
      <div className='password-container'>
        <img
          className='logo-img'
          src='/svgs/logo_2.png'
          alt='wander logo'
        />
        <h2 className='password-h2'>Beta Access</h2>
        <h1 className='password-h1'>Invitation Code</h1>
        <form
          className={`password-form${isWrongPassword ? ' password-form-wrong' : ''}`}
          onSubmit={(e) => {
            e.preventDefault();
            const passwordInput = (e.target as HTMLFormElement).elements.namedItem(
              'password'
            ) as HTMLInputElement;
            checkPassword(passwordInput?.value);
          }}
        >
          <input
            className='password-input'
            type='text'
            name='password'
          />
          <button
            className='password-button'
            type='submit'
          >
            Enter ↵
          </button>
        </form>
        <div className='password-error'>{isWrongPassword && 'Invitation code not valid'}</div>
      </div>
      <footer className='made-with-love-footer'>
        Made with ❤️ from a team of passionate travelers
      </footer>
    </div>
  );
}

PasswordProtect.displayName = 'PasswordProtect';
export default PasswordProtect;
